export class SearchToggle {
    constructor(public bodyElement: any) {
        let searchTrigger = document.getElementById('searchToggle');
        let searchContainer = document.getElementById('siteSearch');

        if (searchTrigger) {
            searchTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                searchContainer.classList.toggle('active');
            });
        }
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/search-toggle.ts